<form
  [formGroup]="form"
  (ngSubmit)="applyUpdate()"
  fxLayout="column"
  fxLayoutAlign="center"
  class="form-fields"
>
  <div
    fxLayout="row"
    fxLayoutAlign="space-between center"
    class="update-create-banner"
    fxFlex="100%"
  >
    <div class="update-create-banner__title">Organization</div>
  </div>
  <div class="update-app-form-container__row">
    <div class="update-app-form-container__grid">
      <aran-input
        type="text"
        placeholder="Enter organization name"
        label="Name"
        formControlName="organizationName"
        [errorMessages]="{
          required: errorMessages.required('Name'),
        }"
      ></aran-input>
    </div>
    <div class="update-app-form-container__grid">
      <aran-input
        type="text"
        placeholder="Enter organization email"
        label="Email"
        formControlName="organizationEmail"
        [errorMessages]="{
          required: errorMessages.required('Email'),
          email: errorMessages.email
        }"
      ></aran-input>
    </div>
    <div class="update-app-form-container__grid">
      <aran-input
        type="text"
        placeholder="Enter organization address"
        label="Address"
        formControlName="organizationAddress"
        [errorMessages]="{
          required: errorMessages.required('Address'),
        }"
      ></aran-input>
    </div>
    <div class="update-app-form-container__grid">
      <aran-input
        type="text"
        placeholder="Enter organization website"
        label="Website"
        formControlName="organizationWebsite"
        [errorMessages]="{
          required: errorMessages.required('Website'),
        }"
      ></aran-input>
    </div>
  </div>

  <div
    fxLayout="row"
    fxLayoutAlign="space-between center"
    class="update-create-banner"
    fxFlex="100%"
  >
    <div class="update-create-banner__title">
      Responsible for general Service consumption matters
    </div>
  </div>
  <div class="update-app-form-container__row">
    <div class="update-app-form-container__grid">
      <aran-input
        type="text"
        placeholder="Enter service name"
        label="Name"
        formControlName="generalSRName"
        [errorMessages]="{
          required: errorMessages.required('Name'),
        }"
      ></aran-input>
    </div>
    <div class="update-app-form-container__grid">
      <aran-input
        type="text"
        placeholder="Enter service surname"
        label="Surname"
        formControlName="generalSRSurName"
        [errorMessages]="{
          required: errorMessages.required('Surname'),
        }"
      ></aran-input>
    </div>
    <div class="update-app-form-container__grid">
      <aran-input
        type="text"
        placeholder="Enter service email"
        label="Email"
        formControlName="generalSREmail"
        [errorMessages]="{
          required: errorMessages.required('Email'),
          email: errorMessages.email
        }"
      ></aran-input>
    </div>
    <div class="update-app-form-container__grid">
      <aran-input
        type="text"
        placeholder="Enter service phone"
        label="Phone"
        formControlName="generalSRPhone"
        [errorMessages]="{
          required: errorMessages.required('Phone'),
        }"
      ></aran-input>
    </div>
  </div>

  <div
    fxLayout="row"
    fxLayoutAlign="space-between center"
    class="update-create-banner"
    fxFlex="100%"
  >
    <div class="update-create-banner__title">
      Responsible for technical matters
    </div>
  </div>
  <div class="update-app-form-container__row">
    <div class="update-app-form-container__grid">
      <aran-input
        type="text"
        placeholder="Enter technical name"
        label="Name"
        formControlName="technicalSRName"
        [errorMessages]="{
          required: errorMessages.required('Name'),
        }"
      ></aran-input>
    </div>
    <div class="update-app-form-container__grid">
      <aran-input
        type="text"
        placeholder="Enter technical surname"
        label="Surname"
        formControlName="technicalSRSurName"
        [errorMessages]="{
          required: errorMessages.required('Surname'),
        }"
      ></aran-input>
    </div>
    <div class="update-app-form-container__grid">
      <aran-input
        type="text"
        placeholder="Enter technical email"
        label="Email"
        formControlName="technicalSREmail"
        [errorMessages]="{
          required: errorMessages.required('Email'),
          email: errorMessages.email
        }"
      ></aran-input>
    </div>
    <div class="update-app-form-container__grid">
      <aran-input
        type="text"
        placeholder="Enter technical phone"
        label="Phone"
        formControlName="technicalSRPhone"
        [errorMessages]="{
          required: errorMessages.required('Phone'),
        }"
      ></aran-input>
    </div>
    <div class="update-app-form-container__grid"></div>
  </div>

  <div class="mt-5">
    <aran-button
      [type]="'submit'"
      [name]="'Apply'"
      [disabled]="!form.valid"
      [className]="!form.valid ? 'btn_disabled' : ''"
    ></aran-button>
  </div>
</form>
